function App() {
  // if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h1>🎬 Lista de Películas</h1>
    </div>
  );
}

export default App;
